import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch {
      setError('Falsche Anmeldedaten');
    }
    setLoading(false);
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <div className="logo">DV <span>ELEKTRO</span></div>
          <div className="sub">Mitarbeiterportal</div>
        </div>

        <form onSubmit={submit}>
          {error && <div className="alert alert-error">{error}</div>}

          <div className="form-group" style={{ marginBottom: 12 }}>
            <label className="form-label">Benutzername</label>
            <input className="form-input" value={username} onChange={e => setUsername(e.target.value)} autoFocus required />
          </div>

          <div className="form-group" style={{ marginBottom: 18 }}>
            <label className="form-label">Passwort</label>
            <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: 12 }} disabled={loading}>
            {loading ? '⏳ Anmelden…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
